<!-- TODO: Refactor into bpb-button -->

<template>
  <div class="input-newsletter__input input-newsletter-button">
    <button
      class="input-newsletter-button__input"
      :type="type"
      :name="name"
      :value="value"
      :disabled="disabled"
      :aria-disabled="disabled"
    >
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'submit',
    },
    name: {
      type: String,
    },
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
